module.exports = __webpack_public_path__ + "img/ione5.534c2004.png";